export default "__VITE_ASSET__CNMRpXWU__"